import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['TICKETS'],
    small: ['TICKETS', 'GET'],
}

export const TextHeaderEn = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="SCRATCH THE TICKETS  AND GET YOUR BONUS
"
            highlights={[{ word: 'YOUR' }, { word: 'BONUS' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
